const live_classes_es = require('./live_classes.json')
export default live_classes_es
